export default (theme) => ({
  root: {
    padding: 24,
  },
  title: {
    marginBottom: 16,
  },
  addSection: {
    marginBottom: 24,
    padding: 16,
    backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    borderRadius: 4,
    border: `1px solid ${theme.palette.divider}`,
  },
  addSectionTitle: {
    marginBottom: 12,
    fontSize: '0.875rem',
    fontWeight: 600,
  },
  addForm: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 50,
  },
  addField: {
    minWidth: 240,
  },
  addButton: {
    textTransform: 'none',
  },
  addError: {
    width: '100%',
    marginTop: 8,
    fontSize: '0.875rem',
  },
  addAclToolbar: {
    marginBottom: 24,
  },
  aclDialogContent: {
    minWidth: 480,
    maxWidth: 640,
    paddingTop: 8,
  },
  aclDialogSearch: {
    marginBottom: 0,
  },
  userPickList: {
    marginTop: 8,
    marginBottom: 8,
    maxHeight: 220,
    overflow: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    backgroundColor: theme.palette.background.paper,
  },
  userPickItem: {
    cursor: 'pointer',
    padding: '10px 14px',
    fontSize: '0.875rem',
    borderBottom: `1px solid ${theme.palette.divider}`,
    transition: 'background-color 0.15s ease',
    '&:last-child': {
      borderBottom: 'none',
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  userPickItemPrimary: {
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  userPickItemSecondary: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    marginTop: 2,
  },
  userPickEmpty: {
    padding: '12px 14px',
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
  },
  selectedUserBanner: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 12,
    marginTop: 12,
    marginBottom: 8,
    padding: '12px 14px',
    borderRadius: 4,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[800],
  },
  selectedUserBannerText: {
    flex: 1,
    minWidth: 0,
  },
  selectedUserName: {
    fontSize: '0.9375rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  selectedUserEmail: {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
    marginTop: 4,
    wordBreak: 'break-all',
  },
  aclDialogForm: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    marginTop: 8,
    '& > *': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  aclOutlinedField: {
    marginTop: 12,
    marginBottom: 4,
  },
  aclSearchHint: {
    marginTop: 8,
    display: 'block',
  },
  roleSelectEmpty: {
    color: theme.palette.text.secondary,
  },
  newAclSectionTitle: {
    marginTop: 16,
  },
  aclDialogSection: {
    marginTop: 16,
    marginBottom: 8,
  },
  aclDialogSectionTitle: {
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    marginBottom: 8,
    color: theme.palette.text.secondary,
  },
  existingAclList: {
    listStyle: 'none',
    padding: 0,
    margin: '0 0 8px 0',
    maxHeight: 200,
    overflow: 'auto',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 4,
    backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
  },
  existingAclItem: {
    padding: '8px 12px',
    fontSize: '0.875rem',
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
});
